import React from 'react';
import TabsComponent from '../../components/Tabs/Tabs';
import Documents from './Documents';

const Index = () => {
    let tabs = [
        {
            name: 'Documents',
            component: (
                <>
                    <Documents />
                </>
            ),
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent selectedIndex={0} tabs={tabs} />
        </div>
    );
};

export default Index;
